import { init } from '@plausible-analytics/tracker'

init({
  domain: 'konflexhub.lacuna-space.com'
})
